module.exports = __webpack_public_path__ + "common/tp-featured1-97846f1880b19795d7974a7835e524fb.svg";